import * as Yup from "yup";

const SocialLinkSchema = Yup.object().shape({
  title: Yup.string().required("Please enter a title").strict().trim(),
  target_url: Yup.string().trim().strict(),
  target_option: Yup.string().trim().strict(),
});

export default SocialLinkSchema;
